import actions from "./actions";

const initState = {
  classification: {},
  loading: false,
  errorMessage: null,
  message: null,
  status: null,
};

export default function createOrUpdateClassificationReducer(
  state = initState,
  action
) {
  switch (action.type) {
    case actions.CREATE_OR_UPDATE_CLASSIFICATION_REQUESTED:
      return {
        ...state,
        classification: {},
        loading: true,
      };
    case actions.CREATE_OR_UPDATE_CLASSIFICATION_SUCCEEDED:
      return {
        ...state,
        classification: action.classification,
        loading: false,
      };
    case actions.CREATE_OR_UPDATE_CLASSIFICATION_FAILED:
      return {
        ...state,
        classification: {},
        loading: false,
        errorMessage: action.error?.message,
        message: action.error?.message,
        status: action.error?.status,
      };
    default:
      return state;
  }
}
